import React, { PureComponent } from 'react';
import { GenericInputValidate } from 'com-gyf-webcore-userinterfacecomponents';

class Referencia extends PureComponent {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        this.props.changeReferencia(event.target.value);
    }

    ValidateReferencia(rule, value, callback) {
        if (value == undefined) {
            callback();
        }
        else {
            if (value.length > 8) {
                callback('La longitud máxima de este campo es de 8 caracteres.');
            }
            else {
                callback();
            }
        }
    }

    render() {
        const me = this;
        const { ingresoCobranza, form } = this.props;
        const { getFieldProps, getFieldError } = form;

        let errors;
        let errorContainer = <label className="error">
            {(errors = getFieldError('inputReferencia')) ? errors.join(',') : null}</label>

        let error = ((getFieldError('inputReferencia')) ? true : false);

        return (
            <div className="row top-separator-xs">
                <div className="col-xs-5">
                    <label className="label-primary">Referencia</label>
                    <GenericInputValidate
                        getFieldProps={getFieldProps('inputReferencia', {
                            onChange(e) {
                                me.onChange(e);
                            },
                            rules: [{
                                validator: this.ValidateReferencia
                            }]
                        })}
                        id="inputReferencia"
                        name="inputReferencia"
                        value={ingresoCobranza.referencia}
                        maxLength="8"
                        className="form-control default-input"
                        type="text"
                        title="Ingrese Referencia."
                    />
                    {error && errorContainer}
                </div>
            </div>
        );
    }
}

export default Referencia;